var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"t",rawName:"v-t",value:('common.no-image'),expression:"'common.no-image'"}],staticClass:"image-placeholder"})}
var staticRenderFns = []

export { render, staticRenderFns }